import React from 'react';
import { HookedSelect } from './HookedSelect';

export type RecurrenceOption =
  | 'none'
  | '1day'
  | '7days'
  | '30days'
  | '90days'
  | '180days'
  | '365days';

export const recurrenceOptions = [
  {
    label: 'None',
    value: 'none',
    raw: 'none' as const,
    intervalDays: 0,
  },
  {
    label: '1 day',
    value: '1day',
    raw: '1day' as const,
    intervalDays: 1,
  },
  {
    label: '7 days',
    value: '7days',
    raw: '7days' as const,
    intervalDays: 7,
  },
  {
    label: '30 days',
    value: '30days',
    raw: '30days' as const,
    intervalDays: 30,
  },
  {
    label: '90 days',
    value: '90days',
    raw: '90days' as const,
    intervalDays: 90,
  },
  {
    label: '180 days',
    value: '180days',
    raw: '180days' as const,
    intervalDays: 180,
  },
  {
    label: '365 days',
    value: '365days',
    raw: '365days' as const,
    intervalDays: 365,
  },
];

export const daysToRecurrenceOption = (days: number): RecurrenceOption => {
  switch (days) {
    case 0:
      return 'none';
    case 1:
      return '1day';
    case 7:
      return '7days';
    case 30:
      return '30days';
    case 90:
      return '90days';
    case 180:
      return '180days';
    case 365:
      return '365days';
    default:
      return 'none';
  }
};

interface Props {
  name: string;
}

export const HookedTaskRecurrenceSelect = (props: Props) => {
  return <HookedSelect name={props.name} options={recurrenceOptions} />;
};
